import { createUseStyles } from 'react-jss'
import ProductItem from '@/components/ProductItem'
import style from './style'

const useStyles = createUseStyles(style)

const RelatedProducts = ({
  items,
}) => {
  const classes = useStyles()

  /*------------------------------
  Add to cart
  ------------------------------*/
  const handleAddToCart = (id, quantity) => {
    if (window.Ecwid) window.Ecwid.Cart.addProduct({ id, quantity })
  }

  return items.length > 0 ? (
    <div className={classes.wrapper}>
      <div className={classes.products}>
        <ul className={classes.productView}>
          {items.map((product) => (
            <ProductItem
              key={product.id}
              item={product}
              shop
              onAddCartClick={() => handleAddToCart(product.id, 1)}
            />
          ))}
        </ul>
      </div>
    </div>
  ) : null
}

export default RelatedProducts
